import { createFileRoute } from "@tanstack/react-router";
import PartsAccountOrders from "@/pages/parts-account/PartsAccountOrders";

export const Route = createFileRoute("/_partsAuth/parts-catalog/account/orders")({
  component: PartsAccountOrders,
});
